import axios from "axios";
import axiosInstance from "./axiosInstance";
import useSWR from "swr";
import { API } from "../constant";

/* ── Authenticated (owner) endpoints ───────────────────────── */

export function useCompanyShare() {
  return useSWR("/company/share");
}

export async function enableShare(orgName, excludedWalletIds = []) {
  const res = await axiosInstance.put("/company/share", {
    orgName,
    excludedWalletIds,
  });
  return res.data;
}

export async function updateShareWallets(excludedWalletIds) {
  const res = await axiosInstance.patch("/company/share/wallets", {
    excludedWalletIds,
  });
  return res.data;
}

export async function revokeShare() {
  return axiosInstance.delete("/company/share");
}

/* ── Public anonymous endpoints (no Authorization header) ──── */
/*
 * Use a bare axios client so the SWR fetcher doesn't accidentally
 * attach a Bearer token from the owner's session. Viewer pages are
 * meant to work in a fresh incognito browser too.
 */
const publicClient = axios.create({ baseURL: API });

const publicFetcher = (url) => publicClient.get(url).then((r) => r.data);

export function usePublicShareSummary(token) {
  return useSWR(token ? `/public/share/${token}/summary` : null, publicFetcher);
}

export function usePublicShareTransactions(token, params = {}) {
  const qs = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => {
    if (v != null && v !== "") qs.set(k, String(v));
  });
  const key = token ? `/public/share/${token}/transactions?${qs.toString()}` : null;
  return useSWR(key, publicFetcher);
}

export function usePublicShareCash(token) {
  return useSWR(token ? `/public/share/${token}/cash` : null, publicFetcher);
}

export function usePublicShareDebts(token) {
  return useSWR(token ? `/public/share/${token}/debts` : null, publicFetcher);
}

export function usePublicWalletBalance(token, walletId) {
  return useSWR(
    token && walletId
      ? `/public/share/${token}/wallet/${walletId}/balance`
      : null,
    publicFetcher
  );
}
